__turbopack_context__.v({
  "cardHolder": "china-fold-out-menu-module-scss-module__hXMLjq__cardHolder",
});
